export const PHARMACY_PICKER_RADIUS_PANEL_TEST_ID = "pharmacy-radius-panel";

export const isPharmacyRadiusPanelEvent = (event: {
	target: EventTarget | null;
	detail?: { originalEvent?: Event };
}): boolean => {
	const target = event.detail?.originalEvent?.target ?? event.target;
	return (
		target instanceof Element &&
		Boolean(
			target.closest(`[data-testid="${PHARMACY_PICKER_RADIUS_PANEL_TEST_ID}"]`),
		)
	);
};
